import { FC } from 'react';
import DateRange, { DateRangeProps } from '../DateRange';
import SearchFormItem from './subpage/searchFormItem';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormDateRangeProps extends BaseSearchFormItemProps {
  /** dateRange Props */
  dateRangeProps?: DateRangeProps;
}
/** 时间段 */
export const SearchFormDateRange: FC<SearchFormDateRangeProps> = props => {
  const {
    dateRangeProps,
    isDetail,
    form,
    name,
    label,
    rules,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || dateRangeProps?.disabled}
      name={name}
      label={label}
      rules={rules}
      validateTrigger="onChange"
    >
      <DateRange
        {...dateRangeProps}
        disabled={isDetail || dateRangeProps?.disabled}
      />
    </SearchFormItem>
  );
};

SearchFormDateRange.displayName = SearchFormItemEnum.SearchFormDateRange;

export default SearchFormDateRange;
